import React from "react";

import {MuiIcon, MuiIconExternalProps} from './MuiIcon';

export const FullscreenExitIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue5d1'}</MuiIcon>
    );
}